import { useMutation, useQuery } from "@tanstack/react-query";
import Api from "../../../features/one-query/services/ApiServices";
import { useAppDispatch } from "../../hooks";
import { setAllTextSuitesApps } from "../../one-query/workflowsSlice";

interface TextSuitesTranslate {
  prompt: string;
  sourceLanguage: string;
  targetLanguage: string;
  connectionId: string;
}

interface TextSuitesHumanizer {
  prompt: string;
  style: string;
  connectionId: string;
}

interface RequestData {
  prompt: string;
  mode?: string;
  purpose?: string;
  connectionId: string;
  textLength?: number;
  brand?: string;
}
//////////////////////////////get All apps//////////////////////
const getAllApps = async () => {
  try {
    const response = await Api.get("Workflow/GetApps");
    return response.data;
  } catch (e) {}
};

export const useGetAllApps = () => {
  return useQuery({
    queryKey: ["GetAllApps"],
    queryFn: getAllApps, 
  });
};
// =================================================================================================
// Translate app endpoint

const textSuitesTranslate = async (
  translateRequestData: TextSuitesTranslate
) => {
  const response = await Api.post("/TextSuits/Translate", translateRequestData);
  return response.data;
};

const useTextSuitesTranslate = () => {
  return useMutation({
    mutationKey: ["TextSuitesTranslate"],
    mutationFn: (translateRequestData: TextSuitesTranslate) =>
      textSuitesTranslate(translateRequestData),
  });
};

// =================================================================================================
// Humanizer app endpoint

const textSuitesHumanizer = async (
  humanizerRequestData: TextSuitesHumanizer
) => {
  const response = await Api.post("/TextSuits/Humanize", humanizerRequestData);
  return response.data;
};

const useTextSuitesHumanizer = () => {
  return useMutation({
    mutationKey: ["TextSuitesHumanizer"],
    mutationFn: (humanizerRequestData: TextSuitesHumanizer) =>
      textSuitesHumanizer(humanizerRequestData),
  });
};

// =================================================================================================
// Summarize app endpoint

const textSuitesSummarize = async (summarizeRequestData: RequestData) => {
  const response = await Api.post("/TextSuits/Summarize", summarizeRequestData);
  return response.data;
};

const useTextSuitesSummarize = () => {
  return useMutation({
    mutationKey: ["TextSuitesSummarize"],
    mutationFn: (summarizeRequestData: RequestData) =>
      textSuitesSummarize(summarizeRequestData),
  });
};

// =================================================================================================
// Paraphrase app endpoint

const textSuitesParaphrase = async (paraphraseRequestData: RequestData) => {
  const response = await Api.post(
    "/TextSuits/Paraphrase",
    paraphraseRequestData
  );
  return response.data;
};

const useTextSuitesParaphrase = () => {
  return useMutation({
    mutationKey: ["TextSuitesParaphrase"],
    mutationFn: (paraphraseRequestData: RequestData) =>
      textSuitesParaphrase(paraphraseRequestData),
  });
};

// =================================================================================================
// AIDetector app endpoint

const textSuitesAIDetector = async (AIDetectorRequestData: RequestData) => {
  const response = await Api.post(
    "/TextSuits/AIDetector",
    AIDetectorRequestData
  );
  return response.data;
};

const useTextSuitesAIDetector = () => {
  return useMutation({
    mutationKey: ["AIDetectorRequestData"],
    mutationFn: (AIDetectorRequestData: RequestData) =>
      textSuitesAIDetector(AIDetectorRequestData),
  });
};

// =================================================================================================
// TitleGeneratorRequestData app endpoint

const textSuitesTitleGenerator = async (
  TitleGeneratorRequestData: RequestData
) => {
  const response = await Api.post(
    "/TextSuits/TitleGenerator",
    TitleGeneratorRequestData
  );
  return response.data;
};

const useTextSuitesTitleGenerator = () => {
  return useMutation({
    mutationKey: ["TitleGeneratorRequestData"],
    mutationFn: (TitleGeneratorRequestData: RequestData) =>
      textSuitesTitleGenerator(TitleGeneratorRequestData),
  });
};

// =================================================================================================
// Prompt engineer app endpoint

const textSuitesPromptEngineer = async (PromptEngineerData: RequestData) => {
  const response = await Api.post(
    "/TextSuits/PromptEngineer",
    PromptEngineerData
  );
  return response.data;
};

const useTextSuitesPromptEngineer = () => {
  return useMutation({
    mutationKey: ["textSuitesPromptEngineer"],
    mutationFn: (PromptEngineerData: RequestData) =>
      textSuitesPromptEngineer(PromptEngineerData),
  });
};

// =================================================================================================

//Get text suite samples endpoint.
const getTextSuitSamples = async () => {
  const response = await Api.get(`/TextSuits/Samples`);
  return response.data;
};

const useGetTextSuitSamples = () => {
  return useMutation({
    mutationKey: ["getTextSuitSamples"],
    mutationFn: () => getTextSuitSamples(),
  });
};

// =================================================================================================

//Improve text suite prompt endpoint.
const improveTextSuitePrompt = async (data: RequestData) => {
  const response = await Api.post(`/TextSuits/EnhancePrompt`, data);
  return response.data;
};

const useImproveTextSuitePrompt = () => {
  return useMutation({
    mutationKey: ["improveTextSuitePrompt"],
    mutationFn: (data: RequestData) => improveTextSuitePrompt(data),
  });
};

export {
  useTextSuitesTranslate,
  useTextSuitesHumanizer,
  useTextSuitesSummarize,
  useTextSuitesParaphrase,
  useTextSuitesAIDetector,
  useTextSuitesTitleGenerator,
  useTextSuitesPromptEngineer,
  useGetTextSuitSamples,
  useImproveTextSuitePrompt
};
